
const formdata = state => state.formdata;
const data = state => param => state.data[param];
const dataobject = state => state.data;
const tags = state => state.tags;
const byFunction = state => state.tags.filter((t)=>{
                    return t.tagcategories.some((tc)=>{
                        return ['Funktion','Anwendungsbereich'].includes(tc.name)
                        })
                    })
const bySeason = state => state.tags.filter((t)=>{
                    return t.tagcategories.some((tc)=>{
                        return ['Saisonalität','Regionalität'].includes(tc.name)
                        })
                    })
const byProduction = state => state.tags.filter((t)=>{
                    return t.tagcategories.some((tc)=>{
                        return ['Serviertemperatur','Herstellungsweise'].includes(tc.name)                        
                        })
                    })
const byAllergenics = state => state.tags.filter((t)=>{
                    return t.tagcategories.some((tc)=>{
                        return ['Allergene und Alkohol','Zusatzstoffe'].includes(tc.name)
                        })
                    })
const byProduct = state => state.tags.filter((t)=>{
                    return t.tagcategories.some((tc)=>{
                        return ['Produktkategorien'].includes(tc.name)
                        })
                    })
const byOther = state => state.tags.filter((t)=>{
                    return t.tagcategories.some((tc)=>{
                        return !['Funktion','Anwendungsbereich',
                                'Saisonalität','Regionalität',
                                'Serviertemperatur','Herstellungsweise',
                                'Allergene und Alkohol','Zusatzstoffe',
                                'Produktkategorien'
                                ].includes(tc.name)
                        })
                    })

const getsingle = state => param =>state.tags.find((a)=> a.id == param)

export default {
  formdata,
  data,
  dataobject,
  tags,
  getsingle,
  byFunction,
  byProduction,
  bySeason,
  byAllergenics,
  byProduct,
  byOther
  
};